import React from "react";
import { map as _map } from "lodash";
import * as styles from "./dispensaryalert.module.css";

import ErrorIcon from "../../elements/icons/ErrorIcon";

import { UsaStates } from "usa-states";

const usStates = new UsaStates();

const DispensaryAlert = (props) => {
  // console.log('DispensaryAlert block props:', props)
  // if (props.status && props.status.success) {
  //   return (
  //     <section className={styles.contact_form}>
  //       <div className={styles.contact_form_container}>
  //         <h3>Thanks for your submission!</h3>
  //       </div>
  //     </section>
  //   );
  // }
  return (
    <>
      <section className={styles.contact_form}>
        <div className={styles.contact_form_container}>
          <form onSubmit={props.handleSubmit}>
            <div className={styles.contact_form_container_name}>
              <div className={styles.row}>
                <input 
                  placeholder="Email Address*" 
                  name="email"
                  disabled={props.isSubmitting || props.status && props.status.success} 
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  value={props.values.email}
                />
                {props.errors.email &&
                props.touched.email &&
                props.errors.email ? (
                  <div className={styles.error}>
                    <ErrorIcon className={styles.error_svg} />
                    {props.errors.email &&
                      props.touched.email &&
                      props.errors.email}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className={styles.contact_form_container_btn}>
              <button 
                disabled={props.isSubmitting || props.status && props.status.success} 
                key={`dispensary-alert`}
                id="submit-dispensary-alert"
                type="submit"
                style={
                  {
                    color: props.isSubmitting || props.status && props.status.success ? '#ccc': 'white',
                    cursor: props.isSubmitting || props.status && props.status.success ? 'not-allowed': 'inherit'
                  }
                }
              >
                { `${props.status && props.status.success ? 'Submitted!' : props.button_text}` }
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default DispensaryAlert;
